// Airport IATA/FAA code → IANA timezone
// IMPORTANT: This map must stay in sync with AIRPORT_TZ in scripts/jetinsight-sync/sync.mjs.
// When adding airport codes, add them to BOTH files.
const AIRPORT_TZ = {
  // Eastern
  ACK: 'America/New_York', BGR: 'America/New_York', BGM: 'America/New_York',
  BHK: 'America/New_York', BKL: 'America/New_York', BNA: 'America/New_York',
  BOS: 'America/New_York', CHS: 'America/New_York', CLT: 'America/New_York',
  DCA: 'America/New_York', EWR: 'America/New_York', GFL: 'America/New_York',
  GON: 'America/New_York', GSO: 'America/New_York', HEF: 'America/New_York',
  IAD: 'America/New_York', ILM: 'America/New_York', JFK: 'America/New_York',
  JYO: 'America/New_York', LGA: 'America/New_York', MCO: 'America/New_York',
  MHT: 'America/New_York', MIA: 'America/New_York', ORF: 'America/New_York',
  ORH: 'America/New_York', PDK: 'America/New_York', PHL: 'America/New_York',
  PIE: 'America/New_York', PSM: 'America/New_York', PVD: 'America/New_York',
  RDU: 'America/New_York', RIC: 'America/New_York', ROC: 'America/New_York',
  RSW: 'America/New_York', SBN: 'America/New_York', SFZ: 'America/New_York',
  SYR: 'America/New_York', TEB: 'America/New_York', TPA: 'America/New_York',
  TYQ: 'America/New_York', APF: 'America/New_York', BWI: 'America/New_York',
  SEG: 'America/New_York', BLF: 'America/New_York', ISM: 'America/New_York',
  DLZ: 'America/New_York', FXE: 'America/New_York', CXU: 'America/New_York', TMB: 'America/New_York', SRQ: 'America/New_York', '07FA': 'America/New_York', TYS: 'America/New_York',
  RYY: 'America/New_York', CGF: 'America/New_York', LEX: 'America/New_York', LCQ: 'America/New_York',
  FTY: 'America/New_York',
  CYQB: 'America/New_York', CYGP: 'America/New_York', MTH: 'America/New_York', SHD: 'America/New_York',
  CHA: 'America/New_York', MYEF: 'America/New_York', AIK: 'America/New_York',
  ORL: 'America/New_York', GRR: 'America/New_York', SDF: 'America/New_York',
  AVL: 'America/New_York', HPN: 'America/New_York', SUA: 'America/New_York',
  DAY: 'America/New_York', HVN: 'America/New_York',
  HII: 'America/Phoenix', FFZ: 'America/Phoenix',
  // Central
  AAO: 'America/Chicago', ACT: 'America/Chicago', AFW: 'America/Chicago',
  AUM: 'America/Chicago', AUS: 'America/Chicago', BHM: 'America/Chicago',
  BNA: 'America/Chicago', CID: 'America/Chicago', DAL: 'America/Chicago',
  DDC: 'America/Chicago', DFW: 'America/Chicago', DSM: 'America/Chicago',
  DWH: 'America/Chicago', ECP: 'America/Chicago', FSD: 'America/Chicago',
  FTW: 'America/Chicago', FWB: 'America/Chicago', FYV: 'America/Chicago',
  GOK: 'America/Chicago', HYI: 'America/Chicago', ICT: 'America/Chicago',
  IXD: 'America/Chicago', JWN: 'America/Chicago', LBF: 'America/Chicago',
  LIT: 'America/Chicago', LNK: 'America/Chicago', LWC: 'America/Chicago',
  MCI: 'America/Chicago', MDW: 'America/Chicago', MEM: 'America/Chicago',
  MKC: 'America/Chicago', MSN: 'America/Chicago', MSP: 'America/Chicago',
  MSY: 'America/Chicago', OKC: 'America/Chicago', OMA: 'America/Chicago',
  ORD: 'America/Chicago', PWA: 'America/Chicago', PWK: 'America/Chicago',
  RVS: 'America/Chicago', SAT: 'America/Chicago', SPW: 'America/Chicago',
  STL: 'America/Chicago', SUS: 'America/Chicago', T82: 'America/Chicago',
  TCL: 'America/Chicago', TKI: 'America/Chicago', TQK: 'America/Chicago',
  TUL: 'America/Chicago', XNA: 'America/Chicago', '4M1': 'America/Chicago', ADS: 'America/Chicago',
  MSL: 'America/Chicago', SLN: 'America/Chicago', STC: 'America/Chicago', OJC: 'America/Chicago', MCK: 'America/Chicago', ANW: 'America/Chicago', BTR: 'America/Chicago', ALN: 'America/Chicago',
  '1K1': 'America/Chicago', UOX: 'America/Chicago', PPF: 'America/Chicago', AIZ: 'America/Chicago', EDC: 'America/Chicago',
  MHK: 'America/Chicago', DUA: 'America/Chicago', CFV: 'America/Chicago', SGR: 'America/Chicago',
  FCM: 'America/Chicago', SGF: 'America/Chicago', AMW: 'America/Chicago', BDH: 'America/Chicago',
  BBG: 'America/Chicago',
  ANB: 'America/Chicago', PIR: 'America/Chicago',
  TXK: 'America/Chicago', RST: 'America/Chicago', HOU: 'America/Chicago',
  GRI: 'America/Chicago', ERV: 'America/Chicago', FWS: 'America/Chicago',
  GCK: 'America/Chicago', PTS: 'America/Chicago', CCY: 'America/Chicago',
  // Mountain
  APA: 'America/Denver', ASE: 'America/Denver', BIL: 'America/Denver', SEZ: 'America/Denver',
  BOI: 'America/Denver', BZN: 'America/Denver', DRO: 'America/Denver',
  EGE: 'America/Denver', GJT: 'America/Denver', GUC: 'America/Denver',
  HDN: 'America/Denver', JAC: 'America/Denver', MYL: 'America/Denver',
  SAF: 'America/Denver', SHR: 'America/Denver', SKX: 'America/Denver',
  COS: 'America/Denver', SLC: 'America/Denver', GPI: 'America/Denver', PUB: 'America/Denver',
  FMN: 'America/Denver', BJC: 'America/Denver',
  // Arizona (Mountain, no DST)
  DTS: 'America/Phoenix', DVT: 'America/Phoenix', FLG: 'America/Phoenix',
  PHX: 'America/Phoenix', PRC: 'America/Phoenix', SDL: 'America/Phoenix',
  TUS: 'America/Phoenix',
  // Pacific
  APC: 'America/Los_Angeles', PSP: 'America/Los_Angeles',
  BUR: 'America/Los_Angeles', LAX: 'America/Los_Angeles', LAS: 'America/Los_Angeles',
  OAK: 'America/Los_Angeles', PAE: 'America/Los_Angeles', RNO: 'America/Los_Angeles',
  SAN: 'America/Los_Angeles', SBA: 'America/Los_Angeles', SEA: 'America/Los_Angeles',
  SFO: 'America/Los_Angeles', SJC: 'America/Los_Angeles', SMF: 'America/Los_Angeles',
  MYV: 'America/Los_Angeles',
  FAT: 'America/Los_Angeles', TVL: 'America/Los_Angeles', WJF: 'America/Los_Angeles', PVS: 'America/Los_Angeles', BVS: 'America/Los_Angeles', RNM: 'America/Los_Angeles',
  TRM: 'America/Los_Angeles', BVU: 'America/Los_Angeles',
  ONT: 'America/Los_Angeles', SBP: 'America/Los_Angeles', UDD: 'America/Los_Angeles',
  // Europe
  EGKB: 'Europe/London', EGLL: 'Europe/London', EGCC: 'Europe/London',
  EDMA: 'Europe/Berlin', EDDF: 'Europe/Berlin', EDDM: 'Europe/Berlin',
  EKBI: 'Europe/Copenhagen', EKCH: 'Europe/Copenhagen',
  EINN: 'Europe/Dublin',
  // Atlantic (no DST)
  TUPJ: 'America/Puerto_Rico',
  MWCR: 'America/Cayman',
  // Mexico
  MMCU: 'America/Chihuahua', MMMY: 'America/Monterrey', MMMX: 'America/Mexico_City',
  MMSD: 'America/Phoenix',
}

// Windows renders European timezone abbreviations as GMT offsets (e.g. "GMT+1")
// instead of the correct abbreviations (BST, CET, CEST). This map corrects them.
const TZ_ABBR_FIX = {
  'Europe/London':     { 'GMT+1': 'BST' },
  'Europe/Dublin':     { 'GMT+1': 'IST' },
  'Europe/Berlin':     { 'GMT+1': 'CET', 'GMT+2': 'CEST' },
  'Europe/Copenhagen': { 'GMT+1': 'CET', 'GMT+2': 'CEST' },
}

function formatFlightTime(dt, airportCode) {
  if (!dt) return ''
  const tz = AIRPORT_TZ[airportCode]
  if (!tz) {
    const d = new Date(dt)
    return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}Z`
  }
  let formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).format(new Date(dt))
  const fixes = TZ_ABBR_FIX[tz]
  if (fixes) {
    for (const [offset, abbr] of Object.entries(fixes)) {
      formatted = formatted.replace(offset, abbr)
    }
  }
  return formatted
}

export function legsTooltip(legs, { showReg = false } = {}) {
  const sorted = [...legs].sort((a, b) => (a.depart_dt || '').localeCompare(b.depart_dt || ''))
  const lines = sorted.map(l => {
    const dep = formatFlightTime(l.depart_dt, l.origin)
    const arr = formatFlightTime(l.arrive_dt, l.destination)
    const times = dep && arr ? `${dep}–${arr}` : dep
    const tbd = l.is_confirmed === false ? ' (TBD)' : ''
    const route = `${l.origin} → ${l.destination}  ${times}${tbd}`
    return showReg ? `[${l.aircraft_reg}] ${route}` : route
  })
  const totalEte = sorted.reduce((s, l) => s + (l.ete_minutes || 0), 0)
  if (totalEte > 0) lines.push(`Total flight time: ${Math.floor(totalEte / 60)}h ${totalEte % 60}m`)
  return lines.join('\n')
}
